/**
 * Custom render function component
 * Created by LKHO on 19/2/2017.
 *
 * this component accepts various template or function input and renders a VNode.
 *
 * Precedence:
 * <code>
 * <li>render => render(createElement)
 * <li>component + data => createElement(component, data)
 * <li>typeof auto === 'function' => render(createElement)
 * <li>auto != null && typeof auto === 'object' => createElement(auto)
 * <li>auto != null => createTextVNode(auto)
 * <li>else return null
 * </code>
 */
export default {
  name: 'render',
  props: {
    render: Function,
    component: Object,
    data: Object,
    auto: {},
  },
  render(createElement) {
    if (this.render) {
      return this.render(createElement)
    } else if (this.component) {
      return createElement(this.component, this.data)
    } else if (typeof  this.auto === 'function') {
      return this.auto(createElement)
    } else if (this.auto != null && typeof this.auto === 'object'
      && (this.auto.template != null || typeof this.auto.render === 'function')) {
      return createElement(this.auto)
    } else if (this.auto != null) {
      return this._v(this.auto)
    }
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/UIComponents/Render.js